<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row>
        <el-form-item
          :label="$l('form_label_operate') || '运营人员'"
          prop="operateCode"
        >
          <dict-select
            v-model="formData.operateCode"
            url="/master/common/dict/baseUserSelect"
            :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            :selectedLabel.sync="formData.operateName"
            clearable
            filterable
            style="width:100%"
          />
        </el-form-item>
      </el-row>
    </el-form>

    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  props: { listCode: { type: Array, default: () => [] } },
  data() {
    return {
      formData: { operateCode: '', operateName: '' },
      backDialogVisible: false,
      rules: {
        operateCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const confirm = await this.$confirm(
        `${this.$l('confirm_setOperate') ||
          '确认要更新listing的运营人员吗？'}<span style="color:#409EFF;font-weight: bold;">${
          this.formData.operateName
        }</span>`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const params = { listCode: this.listCode, ...this.formData }
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuStoreSetOperateApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '更新失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '更新成功！',
        type: 'success',
      })

      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style scoped></style>
